import { AiOutlineSearch } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoIosSettings } from "react-icons/io";
import { TbLogout2 } from "react-icons/tb";
import ToolTip from "../CustomComponents/ToolTip";
import styles from "./styles/Navbar.module.scss";

export default function Navbar({
  isSearchBar = true,
  handleToggle,
  handleLogoutModalOpen,
  handleSettings,
}) {
  return (
    <div className={styles.Navbar}>
      <div className={styles.titleContainer}>
        <span onClick={handleToggle} className={styles.toggleButton}>
          <GiHamburgerMenu />
        </span>
        {/* <h3 className={styles.title}>{title}</h3> */}
      </div>
      {isSearchBar ? (
        <div className={styles.search}>
          <div className={styles.searchButton}>
            <AiOutlineSearch />
          </div>
          <input
            type="text"
            placeholder="Search "
            // value={search}
            // onChange={(e) => dispatch(setValue(e.target.value))}
          />
        </div>
      ) : (
        ""
      )}

      <ToolTip placement={"bottom"} content={"Settings"}>
        <span
          className={`${styles.logoutBtn} bg-secondary-hover`}
          onClick={handleSettings}
          title="settings"
        >
          <IoIosSettings />
        </span>
      </ToolTip>

      <ToolTip placement={"bottom"} content={"Logout"}>
        <span
          className={`${styles.logoutBtn} bg-secondary-hover`}
          onClick={handleLogoutModalOpen}
          title="logout"
        >
          <TbLogout2 />
        </span>
      </ToolTip>
    </div>
  );
}
